/**
 * Standardized localStorage keys for authentication
 * Use these constants throughout the application to ensure consistency
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  CURRENT_USER: 'currentUser',
  USER_ID: 'user_id',
  IS_AUTHENTICATED: 'isAuthenticated'
} as const;
